import React from "react";
const IconGoogleColor = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#4285F4"
      d="M20 10.226c0-.659-.06-1.284-.162-1.892h-9.621v3.758h5.508c-.246 1.234-.97 2.275-2.043 2.984l3.287 2.5c1.924-1.742 3.03-4.309 3.03-7.35Z"
    />
    <path
      fill="#34A853"
      d="M10.216 20c2.76 0 5.066-.9 6.752-2.425l-3.286-2.5c-.92.6-2.086.966-3.466.966-2.665 0-4.92-1.758-5.73-4.133l-3.388 2.575C2.775 17.75 6.223 20 10.216 20Z"
    />
    <path
      fill="#FBBC05"
      d="M4.487 11.91A5.69 5.69 0 0 1 4.163 10c0-.666.12-1.307.324-1.907L1.098 5.518A9.714 9.714 0 0 0 0 10c0 1.617.4 3.133 1.098 4.483l3.389-2.575Z"
    />
    <path
      fill="#EA4335"
      d="M10.216 3.958c1.508 0 2.853.509 3.917 1.5l2.912-2.85C15.282.992 12.975 0 10.216 0 6.223 0 2.775 2.25 1.098 5.517l3.388 2.575c.81-2.375 3.065-4.134 5.73-4.134Z"
    />
  </svg>
);
export default IconGoogleColor;
